<template>
  <div>
    <v-progress-linear indeterminate color="var(--color-primary)" v-if="loading"></v-progress-linear>

    <LiveDetail v-if="getEventsLiveDetail.length > 0 && !accordionEventId"></LiveDetail>

    <v-card class="tournament-card-preview" >

      <div class="sport-live-content">
        <div :class="isInHomePage && isSmallScreen ? 'filters-header' : ''" v-if="showSports">
          <SmartToolbarAmerican
              :groups="sportGroups"
              :group-selected="String(getActiveSportIdLivePreview)"
              :tabs-scrollable="false"
              :show-expand-collapse="false"
              :show-search="false"
              @update:groupSelected="onSportSelected"
              v-if="isInHomePage"
          />

          <div class="lsb-bar" v-else>
            <div class="lsb-scroll-wrapper">
              <button v-if="!isSmallScreen" class="lsb-scroll-btn left"
                      :class="{ active: showSportsLeftArrow }" @click="scrollSportsBar(-1)">‹
              </button>
              <div class="lsb-scroll-track">
                <div class="lsb-fade-edge left" v-show="showSportsLeftArrow"></div>
                <div class="lsb-fade-edge right" v-show="showSportsRightArrow"></div>
                <div class="lsb-scroll" ref="liveSportsScroll" @scroll.passive="updateSportsArrows">
                  <button
                      v-for="sport in getSportsLiveAvailable"
                      :key="sport.id"
                      :ref="`lsport_${sport.id}`"
                      class="lsb-sport-btn"
                      :class="{ 'is-active': String(getActiveSportIdLivePreview) === String(sport.id) }"
                      @click="onSportSelected(sport.id)"
                  >
                    <div>
                      <img class="lsb-sport-icon" :src="`${sportPath}${sport.id}.svg`"
                           :alt="sport.name" @error="e => e.target.style.display = 'none'"/>
                      <span class="lsb-sport-name">{{ sport.name }}</span>
                    </div>
                  </button>
                </div>
              </div>
              <button v-if="!isSmallScreen" class="lsb-scroll-btn right"
                      :class="{ active: showSportsRightArrow }" @click="scrollSportsBar(1)">›
              </button>
            </div>

            <!-- Prematch pinned button -->
          </div>
          <div class="market-dropdown" v-if="false">
            <MarketDropdown
                :isSmallScreen="isSmallScreen"
                :allHeaderMarkets="allHeaderMarkets"
                :selectedMarketIndex="selectedMarketIndex"
                :currentMobileMarketName="currentMobileMarketName"
                @select="selectMobileMarket"
            />
          </div>
        </div>

        <SkeletonPreview v-if="getLoadingLive" :dynamicGridStyle="dynamicGridStyle"
                         :isSmallScreen="isSmallScreen" :maxMarkets="maxMarkets"/>

        <div class="preview pa-0" v-if="!getLoadingLive">
          <div class="tournament-card-preview">


            <div
                class="market-selection-bar-desktop"
                v-if="!isSmallScreen && allHeaderMarkets.length > maxMarkets"
                :style="dynamicGridStyle"
            >
              <div class="grid-cell col-info spacer"></div>

              <div
                  v-for="(i, index) in maxMarkets"
                  :key="'top_sel_' + index"
                  class="grid-cell col-center"
              >
                <div class="custom-native-select-wrapper">
                  <select
                      class="custom-native-select"
                      :value="getDesktopSelectedIndex(index)"
                      @change="onDesktopColumnChange($event.target.value, index)"
                  >
                    <option
                        v-for="opt in getAvailableMarketsForColumn(index)"
                        :key="opt.originalIndex"
                        :value="opt.originalIndex"
                        :disabled="opt.disabled"
                    >
                      {{ opt.marketAlias || opt.marketName }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="grid-cell col-more spacer"></div>
            </div>

            <div v-if="sectionizedGroups.length > 0">
              <template v-for="item in sectionizedGroups">
                <div class="tournament-single"
                     v-if="isFiltered(item.raw[0].categoryId) && isTournamentFiltered(item.raw[0].tournamentId)"
                     :key="item.groupKey">

                  <template v-for="(section, secIdx) in item.allSections">

                    <div class="overtime-divider"
                         v-if="section.isOvertime && section.isMixed && section.isFirstOvertimeSection"
                         v-show="isGroupOpen(item.groupKey)"
                         :key="'div_' + section.sKey + '_' + item.raw[0].tournamentId">
                    </div>

                    <div class="penalty-divider"
                         v-if="section.isPenalty && section.isMixed && section.isFirstPenaltySection"
                         v-show="isGroupOpen(item.groupKey)"
                         :key="'pdiv_' + section.sKey + '_' + item.raw[0].tournamentId">
                      <span class="penalty-label">{{ $t('penalty') }}</span>
                    </div>

                    <div class="grid-row header-sub-row"
                         :class="{
                                             'header-overtime': section.isOvertime,
                                             'header-penalty':  section.isPenalty,
                                             'accordion-header': secIdx === 0,
                                             'accordion-header--closed': secIdx === 0 && !isGroupOpen(item.groupKey)
                                         }"
                         :style="section.isPenalty ? dynamicGridStylePenalty : section.isOvertime ? dynamicGridStyleOvertime : dynamicGridHeaderStyle"
                         v-show="secIdx === 0 || isGroupOpen(item.groupKey)"
                         @click.stop="secIdx === 0 ? toggleGroup(item.groupKey) : undefined"
                         :key="'hdr_' + section.sKey + '_' + item.raw[0].tournamentId">
                      <div class="grid-cell col-info path-container">
                        <span class="tournament-text "
                              :title="item.raw[0].categoryName">{{ item.raw[0].categoryName }} - {{ item.raw[0].tournamentName }}</span>
                        <span class="penalty-section-label ml-2"
                              v-if="section.isPenalty && section.isFirstPenaltySection">{{ $t('penalty') }}</span>
                      </div>
                      <template v-for="(mrkt, hIdx) in section.headers">
                        <div v-if="mrkt && (!isSingleMarket || hIdx === 0)" class="grid-cell col-center"
                             :key="'sub_head_' + section.sKey + '_' + (mrkt.key || mrkt.marketId)">
                          <template v-if="isGroupOpen(item.groupKey)">
                            <!-- Single market: outcome names as sub-columns -->
                            <div v-if="isSingleMarket" class="outcome-names-header">
                              <span
                                  v-for="(name, i) in getOutcomeNamesForHeader(mrkt)"
                                  :key="i"
                                  class="market-header-text outcome-name-col"
                              >{{ name }}</span>
                            </div>
                            <!-- Multi market: market name -->
                            <span v-else class="market-header-text">
                              {{ mrkt.marketAlias || mrkt.marketName }}
                            </span>
                          </template>
                        </div>
                      </template>
                      <!-- col-more: chevron desktop alla fine della riga -->
                      <div class="grid-cell col-more">
                        <v-icon v-if="secIdx === 0 && !isSmallScreen" class="accordion-chevron"
                                x-small>
                          {{ isGroupOpen(item.groupKey) ? 'mdi-chevron-up' :
                            'mdi-chevron-down' }}
                        </v-icon>
                      </div>
                      <!-- chevron mobile: posizione assoluta a destra -->
                      <v-icon v-if="secIdx === 0 && isSmallScreen"
                              class="accordion-chevron accordion-chevron--abs" x-small>
                        {{ isGroupOpen(item.groupKey) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                      </v-icon>
                    </div>

                    <template v-for="(event, evtIdx) in section.events">
                      <div class="matches-list"
                           v-show="isGroupOpen(item.groupKey)"
                           :key="event.id"
                           :class="{ 'event-matches--new': event.isNewlyAdded, 'event-matches--leaving': event.isLeaving }">
                        <div class="event-row" :class="{ 'event-row--finished': event.matchFinished, 'event-row--extended': isExtendedView }">
                          <div class="event-timer-row">
                            <div class="event-inline-timer">
                              <template v-for="_ats in [isAboutToStart(event)]">
                                <span class="inline-time" v-if="!_ats">{{ getInfoTimeMatch(event.livescore, event.sportId, event.status) }}</span>
                                <Countdown :scheduled="event.scheduled" v-if="_ats" />
                                <span class="inline-time" v-else-if="!event.matchFinished && event.livescore && event.livescore.scoreboard && event.livescore.scoreboard.time != CLOCK.INVALID && event.livescore.scoreboard.time != CLOCK.NOT_STARTED">
                                  {{ getMatchCurrentTime(getDisplaySeconds(event)) }}'
                                </span>
                              </template>
                            </div>
                          </div>
                          <div class="grid-row " :class="(evtIdx % 2 == 0) ? 'even' : 'odd'"
                               :style="section.isPenalty ? dynamicGridStylePenalty : section.isOvertime ? dynamicGridStyleOvertime : dynamicGridStyle">

                            <div class="grid-cell col-info match-info-container clickable-cell"
                                 @click="goToEventDetail(event)">
                              <div class="info-body-block">
                                <div class="competitors-block">
                                  <div class="team-name home" :title="event.home">
                                    <LogoCompetitors :team-id="event.home_id"
                                                     width="18px" height="auto"
                                                     v-if="!isTennisOrTableTennis(event)"/>
                                    <div class="ping-serving"
                                         :class="isServing(event.livescore, '1') ? 'live' : ''"
                                         v-else></div>

                                    <span class="competitor-name">{{ event.home }}</span>
                                    <div class="incidents-box">
                                      <transition name="incident-slide">
                                                                                <span class="incident-badge goal-badge"
                                                                                      v-if="hasGoalIncident(event, '1') && String(event.sportId) === SPORT_ID.SOCCER">GOAL</span>
                                      </transition>
                                      <transition name="incident-slide">
                                                                                <span class="incident-badge var-badge"
                                                                                      v-if="hasVarIncident(event)">VAR</span>
                                      </transition>
                                      <div class="cards-box"
                                           v-if="showRedCards(event)">
                                        <div v-if="parseInt(getStat(event.livescore, STAT_TYPE.RED_CARDS, '1')) > 1"
                                             class="card-min red">
                                          {{parseInt(getStat(event.livescore,
                                            STAT_TYPE.RED_CARDS, '1'))}}
                                        </div>
                                        <div v-for="n in (parseInt(getStat(event.livescore, STAT_TYPE.RED_CARDS, '1')) || 0)"
                                             v-else :key="'r1'+n"
                                             class="card-min red"></div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="team-name away" :title="event.away">
                                    <LogoCompetitors :team-id="event.away_id"
                                                     width="18px" height="auto"
                                                     v-if="!isTennisOrTableTennis(event)"/>
                                    <div class="ping-serving"
                                         :class="isServing(event.livescore, '2') ? 'live' : ''"
                                         v-else></div>


                                    <span class="competitor-name">{{ event.away }}</span>
                                    <div class="incidents-box">
                                      <transition name="incident-slide">
                                                                                <span class="incident-badge goal-badge"
                                                                                      v-if="hasGoalIncident(event, '2') && String(event.sportId) === SPORT_ID.SOCCER">GOAL</span>
                                      </transition>
                                      <div class="cards-box"
                                           v-if="showRedCards(event)">
                                        <div v-if="parseInt(getStat(event.livescore, STAT_TYPE.RED_CARDS, '2')) > 1"
                                             class="card-min red">
                                          {{parseInt(getStat(event.livescore,
                                            STAT_TYPE.RED_CARDS, '2'))}}
                                        </div>
                                        <div v-for="n in (parseInt(getStat(event.livescore, STAT_TYPE.RED_CARDS, '2')) || 0)"
                                             v-else :key="'r2'+n"
                                             class="card-min red"></div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="score-block">
                                  <div class="match-score score-animate"
                                       :key="getScoreString(event)">
                                    <ScoreboardLiveAmerican :sport-id="event.sportId" :livescore="event.livescore"/>
                                  </div>
                                  <div class="period-text" v-if="event.livescore && event.livescore.scoreboard">{{ getMatchCurrentPeriod(event.livescore.scoreboard.currentPeriod) }}</div>
                                </div>
                              </div>
                            </div>

                            <template v-for="(mrktDef, renderIdx) in section.headers">
                              <div v-if="mrktDef && (!isSingleMarket || renderIdx === 0)" class="grid-cell col-center"
                                   :key="event.id + '_col_' + renderIdx">
                                <template
                                    v-for="resolvedMarket in [event.resolvedGridMarkets[mrktDef.key || mrktDef.marketId]]">
                                  <!-- Calcola 1 volta per cella: hasSpec, showSpec, outcomeStyle -->
                                  <template
                                      v-for="[hasSpec, showSpec, outcomeStyle] in [[hasSpecifier(resolvedMarket), shouldShowSpecifierPlaceholder(mrktDef) || hasSpecifier(resolvedMarket), getOutcomeStyle(mrktDef)]]">
                                    <div class="inner-grid" v-if="resolvedMarket"
                                         :style="getInnerGridStyle(mrktDef, resolvedMarket)"
                                         :key="event.id + '_inner_' + renderIdx">
                                      <template
                                          v-if="resolvedMarket.outcome && resolvedMarket.outcome.length > 0">
                                        <div v-if="!resolvedMarket.void"
                                             class="outcome-box"
                                             :style="outcomeStyle"
                                             v-for="odd in resolvedMarket.outcome"
                                             :key="odd.unique_id || odd.id">
                                          <template
                                              v-if="oddsVisualMode === 'arrows'">
                                            <v-icon class="arrow-up"
                                                    v-if="odd.type_change == 'up' && isOddPlayable(odd)">
                                              mdi-arrow-up
                                            </v-icon>
                                            <v-icon class="arrow-down"
                                                    v-if="odd.type_change == 'down' && isOddPlayable(odd)">
                                              mdi-arrow-down
                                            </v-icon>
                                          </template>
                                          <div v-if="isOddPlayable(odd)"
                                               class="value clickable"
                                               :class="getOddClasses(odd)"
                                               @click="putCart(resolvedMarket, odd, event, {id: item.raw[0].sportId}, {id: item.raw[0].categoryId}, {id: item.raw[0].tournamentId})">
                                            <span class="outcome-name-row">
                                              <span class="outcome-name">
                                                {{ getOutcomeName(event.competitors, odd, resolvedMarket.unique_id) }}
                                              </span>
                                              <span v-if="getPlayerOutcomeLine(odd) || (resolvedMarket.specifier && resolvedMarket.specifier !== 'noSpec' && resolvedMarket.specifier !== '')" class="odd-line-val">
                                                {{ getPlayerOutcomeLine(odd) || formatLineDisplay(odd.line, resolvedMarket) }}
                                              </span>
                                            </span>
                                            <span class="outcome-value">{{ odd.outcome_odd_value | odds_type_filter }}
                                              <OddBoostBadge :odd="odd" size="sm" :show-percent="false"/>
                                            </span>
                                          </div>
                                          <div v-else class="value locked">
                                            <v-icon dense small>mdi-lock
                                            </v-icon>
                                          </div>
                                        </div>
                                      </template>
                                      <template v-else>
                                        <div class="outcome-box"
                                             :style="outcomeStyle"
                                             v-for="n in (mrktDef.outcomeNames ? mrktDef.outcomeNames.length : (mrktDef.outcomeNumbers || 3))"
                                             :key="'force_lock_empty_' + n">
                                          <div class="value locked">
                                            <v-icon dense small>mdi-lock
                                            </v-icon>
                                          </div>
                                        </div>
                                      </template>
                                    </div>
                                    <div class="inner-grid" v-else
                                         :key="event.id + '_inner_missing_' + renderIdx"
                                         :style="getInnerGridStyle(mrktDef)">
                                      <template
                                          v-if="shouldShowSpecifierPlaceholder(mrktDef)">
                                        <div class="outcome-box"
                                             :style="isSmallScreen ? 'grid-column: span 6;' : ''">
                                          <div class="value locked">
                                            <v-icon dense small>mdi-lock
                                            </v-icon>
                                          </div>
                                        </div>
                                      </template>
                                      <div class="outcome-box"
                                           :style="outcomeStyle"
                                           v-for="n in (mrktDef.outcomeNames ? mrktDef.outcomeNames.length : (mrktDef.outcomeNumbers || 3))"
                                           :key="'force_lock_missing_' + n">
                                        <div class="value locked">
                                          <v-icon dense small>mdi-lock
                                          </v-icon>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </template>
                              </div>
                            </template>

                            <!-- Expand button -->
                            <div class="grid-cell col-more mlp-expand-cell">
                              <button
                                class="mlp-expand-btn"
                                :class="{ open: isEventExpanded(event.id) }"
                                @click.stop="toggleEventExpand(event)"
                              >
                                <svg viewBox="0 0 10 10" width="10" height="10">
                                  <line x1="5" y1="1" x2="5" y2="9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                  <line v-if="!isEventExpanded(event.id)" x1="1" y1="5" x2="9" y2="5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                              </button>
                            </div>

                          </div>
                        </div>

                        <!-- Accordion live detail -->
                        <transition name="mlp-detail-fade">
                          <div v-if="isEventExpanded(event.id)" class="mlp-event-accordion">
                            <div v-if="accordionLoading" class="mlp-accordion-loading">
                              <v-progress-circular indeterminate size="28" width="2" color="var(--color-primary)"></v-progress-circular>
                            </div>
                            <LiveDetail v-else />
                          </div>
                        </transition>

                      </div>
                    </template>

                  </template>
                </div>
              </template>

              <div class="load-more-wrapper"
                   v-if="getPagination && getPagination.page < getPagination.totalPages && showMoreEventButton && !getActiveTournamentIdLivePreview.length">
                <button class="primary-button" @click="loadMoreEvents" :disabled="getLoadingMore">
                  <v-progress-circular v-if="getLoadingMore" indeterminate size="16" width="2"
                                       color="var(--color-accent)"></v-progress-circular>
                  <span v-else>{{ $t('load_more') }} ({{getPagination.total - (getPagination.page * getPagination.limit)}})<v-icon
                      x-small class="ml-2">{{ 'mdi-chevron-down' }}</v-icon>
                                    </span>
                </button>
              </div>

            </div>

            <div v-else-if="!isInHomePage" class="empty-market-state">
              <div class="empty-state-card">
                <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 17C9.85038 16.3697 10.8846 16 12 16C13.1154 16 14.1496 16.3697 15 17"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                  <ellipse cx="15" cy="10.5" rx="1" ry="1.5" fill="currentColor"/>
                  <ellipse cx="9" cy="10.5" rx="1" ry="1.5" fill="currentColor"/>
                  <path d="M22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C21.5093 4.43821 21.8356 5.80655 21.9449 8"
                        stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
              </div>
              <span class="empty-text_t">{{ $t('market_empty') }}</span>
              <span class="empty-text_p">{{ $t('check_or_change_sport') }}</span>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import LiveDetail from "@/components/center_widgets/LiveDetail.vue";
import {resolveEventMarket} from '@/utils/marketLineUtils';
import ScoreboardLiveAmerican from "@/components/american/ScoreboardLiveAmerican.vue";
import LogoCompetitors from "@/components/center_widgets/LogoCompetitors.vue";
import {isMobileOnly, isTablet} from "mobile-device-detect";
import _ from 'lodash';
import MarketDropdown from "@/components/generic/MarketDropdown.vue";
import SkeletonPreview from "@/components/center_widgets/Live/SkeletonPreview.vue";
import DynamicDropdownModal from "@/components/generic/DynamicDropdownModal.vue";
import Countdown from "@/components/center_widgets/Live/Countdown.vue";
import GeneralSpreadSelectorLive from "@/components/center_widgets/Live/previews/GeneralSpreadSelectorLive.vue";
import SmartToolbarAmerican from "@/components/american/SmartToolbarAmerican.vue";
import OddBoostBadge from '@/components/generic/OddBoostBadge.vue';
import {MARKET_ASIAN_HANDICAP, MARKET_NOT_NAME_IN_OUTCOME} from '../../constants/marketConstants';


const ENABLE_LOCAL_CLOCK_TICK = false; // todo PLEASE AT THE MOMENTO DONT ACTIVE THIS ELSE THERE WILL BE A MEMORY LEAK , for do this need create a separate LiveEventclock :event="event"

// Named constants
const EVENT_STATUS = {
  LIVE: '2',
  STARTING_SOON: '9',
  FINISHED: '3',
};
const SPORT_ID = {
  SOCCER: '6046',
  TENNIS: '54094',
  TABLE_TENNIS: '265917',
};
const INCIDENT_ID = {
  GOAL: '9',    // lsport incident type: goal scored
  VAR: '1074', // lsport incident type: VAR review
};
const STAT_TYPE = {
  RED_CARDS: 7, // lsport stat: number of red-card events (icon count)
};
const CLOCK = {
  INVALID: '-1', // scoreboard.time sentinel: data unavailable
  NOT_STARTED: '0',  // scoreboard.time sentinel: match not yet kicked off
};
const DRAW_OUTCOME_ID = '128';
const COUNTDOWN_SPORT_IDS = new Set([48242, 1149105, 1149097, 35232, 530129, 46957]);
// ─────────────────────────────────────────────────────────────────────────────

//stable version 3.0 fixed memory leak 16/04/2026

export default {
  name: 'MarketLivePreviewV8Terminal',
  props: {
    pageLimit: {type: Number, default: 100},
    showMoreEventButton: {type: Boolean, default: true},
    showSports: {type: Boolean, default: true},
    isInHomePage: {type: Boolean, default: false},
    /** When set, forces the live section to this sport on mount and on change (used inside PreliveSection). */
    sportId: {type: [Number, String], default: null},
  },
  components: {
    Countdown,
    GeneralSpreadSelectorLive,
    ScoreboardLiveAmerican,
    LiveDetail,
    LogoCompetitors,
    OddBoostBadge,
    MarketDropdown,
    SkeletonPreview,
    DynamicDropdownModal,
    SmartToolbarAmerican
  },
  data: () => ({
    // Constants exposed to the template (frozen → Vue skips deep observation)
    SPORT_ID: Object.freeze({SOCCER: '6046', TENNIS: '54094', TABLE_TENNIS: '265917'}),
    STAT_TYPE: Object.freeze({RED_CARDS: 7}),
    CLOCK: Object.freeze({INVALID: '-1', NOT_STARTED: '0'}),
    isMobileOnly: isMobileOnly,
    isTablet: isTablet,
    loading: false,
    categoryPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/categories/round_flags/',
    categories_filtered: [],
    markets: [],
    maxMarkets: 3,
    infoColWidth: '350px',
    moreColWidth: '50px',
    oddsVisualMode: 'blink',
    selectedMarketIndex: 0,
    sportPath: process.env.VUE_APP_URL_CLOUDFRONT + '/svg/sports/icons-color/',
    light: (window.icons == 'light'),
    isSmallScreen: false,
    customLines: {},
    openGroups: {},
    _userToggled: {},
    showCatsLeftArrow: false,
    showCatsRightArrow: false,
    showSportsLeftArrow: false,
    showSportsRightArrow: false,
    liveTick: 0, // incrementato ogni secondo: forza il ricalcolo di getDisplaySeconds()
    varLinger: {}, // eventId → true finché il badge VAR deve restare visibile (incluso linger 10s)
    desktopMarketIndices: [0, 1, 2],
    desktopMarketIndicesOvertime: [0, 1, 2],
    desktopMarketIndicesPenalty: [0, 1, 2],
    accordionEventId: null,
    accordionLoading: false,
  }),
  computed: {
    ...mapGetters({
      'getPreviewLive': 'previewLive/getPreviewLive',
      'getLoadingLive': 'previewLive/isLoadingLive',
      'getLoadingMore': 'previewLive/isLoadingMore',
      'getPagination': 'previewLive/getPagination',
      'getEventsLiveDetail': 'detailLive/getEventsLiveDetail',
      'getLanguage': 'settings/getLanguage',
      'getOddsSources': 'cart/getOddsSources',
      'getSportsLiveAvailable': 'marketview/getSportsLiveAvailable',
      'getActiveSportIdLivePreview': 'marketview/getActiveSportIdLivePreview',
      'getActiveTournamentIdLivePreview': 'marketview/getActiveTournamentIdLivePreview',
      'getCategoryLiveAvailable': 'marketview/getCategoryLiveAvailable',
      'getActiveSportId': 'topsports/getActiveSportId',
      'getLivePollingIntervalMs': 'settings/getLivePollingIntervalMs',
      'activeGoalEvents': 'previewLive/getActiveGoalEvents',
      'getType': 'user/getType',
      'getCashier': 'user/getCashier',
      'getEnableQuickBetOnlyForAgency': 'settings/getEnableQuickBetOnlyForAgency',
      'getEventViewMode': 'ui/getEventViewMode',
      'getBet':                    'cart/getBet',
      'getSettings':               'cart/getSettings',
      'getTournamentsActive':      'previewPrematch/getTournamentsActive',
      'getEventsDetail':           'detailPrematch/getEventsDetail',
      'getEventsLiveDetailActive': 'detailLive/getEventsLiveDetailActive',
      'getConfirmedBet':           'cart/getConfirmedBet',
      'getAppSection':             'ui/getAppSection',
      'getMarketConfig':              'settings/getMarketConfig',
      'getCompetitorsInOutcome':      'settings/getCompetitorsInOutcome',

    }),

    isExtendedView() {
      return this.isSmallScreen && this.getEventViewMode === 'extended';
    },

    showQbet() {
      if (this.getEnableQuickBetOnlyForAgency) {
        return this.getCashier || this.getType == 4
      }
      return true
    },

    sportGroups() {
      return (this.getSportsLiveAvailable || []).map(s => ({
        _id: String(s.id),
        name: s.name
      }));
    },
    getGroupedEvents() {
      return (this.getPreviewLive && this.getPreviewLive.events) ? this.getPreviewLive.events : [];
    },
    getHeaderSign() {
      return (this.getPreviewLive && this.getPreviewLive.headerSign) ? this.getPreviewLive.headerSign : [];
    },
    getHeaderSignOvertime() {
      return (this.getPreviewLive && this.getPreviewLive.headerSignOvertime) ? this.getPreviewLive.headerSignOvertime : null;
    },
    getHeaderSignPenalty() {
      return (this.getPreviewLive && this.getPreviewLive.headerSignPenalty) ? this.getPreviewLive.headerSignPenalty : null;
    },

    allHeaderMarkets() {
      return this.getHeaderSign || [];
    },
    visibleMarkets() {
      if (!this.allHeaderMarkets || this.allHeaderMarkets.length === 0) return [];
      const selectedMarkets = [];
      for (let i = 0; i < this.maxMarkets; i++) {
        let targetIndex = this.desktopMarketIndices[i] !== undefined ? this.desktopMarketIndices[i] : i;
        if (targetIndex >= this.allHeaderMarkets.length) targetIndex = i < this.allHeaderMarkets.length ? i : 0;
        selectedMarkets.push(this.allHeaderMarkets[targetIndex]);
      }
      return selectedMarkets;
    },

    isSingleMarket() {
      return this.allHeaderMarkets.length === 1;
    },

    allHeaderMarketsOvertime() {
      return this.getHeaderSignOvertime || [];
    },
    visibleMarketsOvertime() {
      if (!this.allHeaderMarketsOvertime || this.allHeaderMarketsOvertime.length === 0) return [];
      const selectedMarkets = [];
      for (let i = 0; i < this.maxMarkets; i++) {
        let targetIndex = this.desktopMarketIndicesOvertime[i] !== undefined ? this.desktopMarketIndicesOvertime[i] : i;
        if (targetIndex >= this.allHeaderMarketsOvertime.length) targetIndex = i < this.allHeaderMarketsOvertime.length ? i : 0;
        selectedMarkets.push(this.allHeaderMarketsOvertime[targetIndex]);
      }
      return selectedMarkets;
    },

    allHeaderMarketsPenalty() {
      return this.getHeaderSignPenalty || [];
    },
    visibleMarketsPenalty() {
      if (!this.allHeaderMarketsPenalty || this.allHeaderMarketsPenalty.length === 0) return [];
      const selectedMarkets = [];
      for (let i = 0; i < this.maxMarkets; i++) {
        let targetIndex = this.desktopMarketIndicesPenalty[i] !== undefined ? this.desktopMarketIndicesPenalty[i] : i;
        if (targetIndex >= this.allHeaderMarketsPenalty.length) targetIndex = i < this.allHeaderMarketsPenalty.length ? i : 0;
        selectedMarkets.push(this.allHeaderMarketsPenalty[targetIndex]);
      }
      return selectedMarkets;
    },

    sectionizedGroups() {
      const hasOT = !!(this.getHeaderSignOvertime && this.getHeaderSignOvertime.length);
      const hasPEN = !!(this.getHeaderSignPenalty && this.getHeaderSignPenalty.length);
      const regularHeaders = this.visibleMarkets || [];
      const overtimeHeaders = this.visibleMarketsOvertime || [];
      const penaltyHeaders = this.visibleMarketsPenalty || [];

      return this.getGroupedEvents
          .filter(group => group && group.length > 0)
          .map(group => {
            const rawRegular = (hasOT || hasPEN) ? group.filter(e => !e.isOvertime && !e.isPenalty) : group;
            const rawOvertime = hasOT ? group.filter(e => e.isOvertime) : [];
            const rawPenalty = hasPEN ? group.filter(e => e.isPenalty) : [];

            const allSections = [];

            if (rawRegular.length > 0) {
              const subGroups = this._groupEventsByHeaders(rawRegular, regularHeaders);
              subGroups.forEach((sg, idx) => {
                allSections.push({
                  isOvertime: false,
                  isPenalty: false,
                  isMixed: false,
                  isFirstOvertimeSection: false,
                  isFirstPenaltySection: false,
                  events: sg.events,
                  headers: sg.headers,
                  sKey: 'reg_' + idx
                });
              });
            }

            if (rawOvertime.length > 0) {
              const subGroups = this._groupEventsByHeaders(rawOvertime, overtimeHeaders);
              subGroups.forEach((sg, idx) => {
                allSections.push({
                  isOvertime: true,
                  isPenalty: false,
                  isMixed: rawRegular.length > 0,
                  isFirstOvertimeSection: idx === 0,
                  isFirstPenaltySection: false,
                  events: sg.events,
                  headers: sg.headers,
                  sKey: 'ot_' + idx
                });
              });
            }

            if (rawPenalty.length > 0) {
              const subGroups = this._groupEventsByHeaders(rawPenalty, penaltyHeaders);
              subGroups.forEach((sg, idx) => {
                allSections.push({
                  isOvertime: false,
                  isPenalty: true,
                  isMixed: rawRegular.length > 0,
                  isFirstOvertimeSection: false,
                  isFirstPenaltySection: idx === 0,
                  events: sg.events,
                  headers: sg.headers,
                  sKey: 'pen_' + idx
                });
              });
            }

            return {
              raw: group,
              allSections,
              groupKey: String(group[0].tournamentId) + '_' + String(group[0].categoryId)
            };
          });
    },

    validCategoriesDisplay() {
      const events = this.getGroupedEvents;
      if (!events || events.length === 0) return [];

      const categoryMap = new Map();

      events.forEach(group => {
        if (group && group.length > 0) {
          const firstEvent = group[0];
          const catId = String(firstEvent.categoryId);
          if (catId && firstEvent.categoryName && !categoryMap.has(catId)) {
            categoryMap.set(catId, {
              id: catId,
              name: firstEvent.categoryName
            });
          }
        }
      });
      return Array.from(categoryMap.values()).sort((a, b) => a.name.localeCompare(b.name));
    },

    filteredCategoriesCount() {
      return this.categories_filtered.length;
    },

    currentMobileMarketName() {
      const m = this.allHeaderMarkets[this.selectedMarketIndex];
      return m ? (m.marketAlias || m.marketName) : (this.allHeaderMarkets.length > 0 ? (this.allHeaderMarkets[0].marketAlias || this.allHeaderMarkets[0].marketName) : 'Select');
    },

    dynamicGridHeaderStyle() {
      const count = this.isSingleMarket ? 1 : (this.visibleMarkets.length || 1);
      return {
        display: 'grid',
        'grid-template-columns': `${count}fr repeat(${count}, minmax(0, 1fr)) 40px`,
        'align-items': 'stretch',
        'border-bottom': '1px solid var(--border-color)',
        width: '100%'
      };
    },

    dynamicGridStyle() { return this._buildGridStyle(this.visibleMarkets.length); },
    dynamicGridStyleOvertime() { return this._buildGridStyle(this.visibleMarketsOvertime.length); },
    dynamicGridStylePenalty()  { return this._buildGridStyle(this.visibleMarketsPenalty.length);  },

    // Mappa eventId → stato VAR grezzo (senza linger), usata per gestire il timer.
    _varStateMap() {
      const map = {}
      const groups = this.getGroupedEvents || []
      groups.forEach(group => {
        ;(group || []).forEach(event => {
          if (!event || !event.id) return
          map[String(event.id)] = this._isVarActiveRaw(event)
        })
      })
      return map
    },
  },
  watch: {
    // VAR linger: quando il segnale VAR si spegne il badge resta visibile per 10 secondi.
    _varStateMap(newMap, oldMap) {
      if (!this._varTimers) this._varTimers = {}
      const old = oldMap || {}
      Object.keys(newMap).forEach(eventId => {
        const isActive = newMap[eventId]
        const wasActive = old[eventId]
        if (isActive) {
          // VAR attivo: mostra badge e cancella eventuale timer di spegnimento
          if (this._varTimers[eventId]) {
            clearTimeout(this._varTimers[eventId]);
            delete this._varTimers[eventId]
          }
          this.$set(this.varLinger, eventId, true)
        } else if (wasActive && !isActive) {
          // VAR appena spento: avvia timer da 10s prima di nascondere il badge
          if (!this._varTimers[eventId]) {
            this._varTimers[eventId] = setTimeout(() => {
              this.$delete(this.varLinger, eventId)
              delete this._varTimers[eventId]
            }, 10000)
          }
        }
      })
      // Cleanup eventi non più presenti nella lista
      Object.keys(old).forEach(eventId => {
        if (!(eventId in newMap)) {
          if (this._varTimers[eventId]) {
            clearTimeout(this._varTimers[eventId]);
            delete this._varTimers[eventId]
          }
          this.$delete(this.varLinger, eventId)
        }
      })
    },

    // Quando le categorie disponibili cambiano (es. eventi finiti rimossi),
    // ripulisce categories_filtered da qualsiasi ID che non esiste più —
    // altrimenti il filtro attivo su una categoria morta nasconde tutti gli altri eventi.
    validCategoriesDisplay(newCats) {
      if (this.categories_filtered.length === 0) return;
      const validIds = new Set(newCats.map(c => c.id));
      this.categories_filtered = this.categories_filtered.filter(id => validIds.has(id));
    },

    // Al cambio sport azzera lo stato accordion (nuovi tornei, fresh start)
    getActiveSportIdLivePreview() {
      this.openGroups = {};
      this._userToggled = {};
    },

    // Gestione filtro multi-torneo live.
    // TreeLive.vue aggiorna solo lo state; questo watcher è l'unico responsabile dei fetch.
    //
    //  [] → [T]               prima selezione   → fetchLive by T       (SET, sostituisce tutto)
    //  [T1] → [T1,T2]         aggiunta          → fetchAndMerge T2     (APPEND, unisce)
    //  [T1,T2] → [T1]         rimozione parz.   → removeTournamentEvents T2 (no API)
    //  [T] → []               svuotamento       → fetchLive full-sport  (SET, ripristina)
    //  [Tv1,Tv2] → [Tf]       sport switch      → fetchLive by Tf      (SET nuovo sport)
    //  [T1..T5] → [T2..T5,T6] coda circolare    → remove T1 + merge T6 (no full reload)
    async getActiveTournamentIdLivePreview(newIds, oldIds) {
      const prev = Array.isArray(oldIds) ? oldIds : [];
      const next = Array.isArray(newIds) ? newIds : [];

      // Sport già aggiornato dallo store prima che questo watcher scatti:
      // confrontiamo con _watcherPrevSportId per sapere se c'è stato un cambio sport.
      const sportChanged = !!this._watcherPrevSportId &&
          String(this.getActiveSportIdLivePreview) !== String(this._watcherPrevSportId);
      this._watcherPrevSportId = String(this.getActiveSportIdLivePreview || '');

      if (prev.length === 0 && next.length === 0) return;

      const added = next.find(id => !prev.some(o => String(o) === String(id)));
      const removed = prev.find(id => !next.some(n => String(n) === String(id)));

      if (next.length === 0) {
        // Tutti deselezionati → full-sport.
        // Se changeLive è in corso, salta: gestirà lui il fetch con parametri completi.
        if (this._changeLiveInProgress) return;
        await this.fetchLive({sport: this.getActiveSportIdLivePreview, page: 1, ishome: this.isInHomePage});

      } else if (added && prev.length === 0) {
        // Prima selezione → SET filtrato per torneo
        await this.fetchLive({
          sport: this.getActiveSportIdLivePreview,
          tournamentId: added,
          page: 1,
          ishome: this.isInHomePage,
        });

      } else if (added && removed) {
        if (sportChanged) {
          // Sport switch: sport cambiato → fresh SET per il nuovo sport
          await this.fetchLive({
            sport: this.getActiveSportIdLivePreview,
            tournamentId: added,
            page: 1,
            ishome: this.isInHomePage,
          });
        } else {
          // Coda circolare: il torneo più vecchio viene espulso, arriva il nuovo.
          // Prima rimuoviamo i dati del vecchio (mutation pulisce store + lookup tables),
          // poi appendiamo il nuovo senza ricaricare tutti gli altri.
          this.removeTournamentEvents(removed);
          await this.fetchAndMergeTournament({
            sport: this.getActiveSportIdLivePreview,
            tournamentId: added
          });
        }

      } else if (added) {
        // Torneo aggiuntivo → APPEND senza perdere i precedenti
        await this.fetchAndMergeTournament({
          sport: this.getActiveSportIdLivePreview,
          tournamentId: added,
        });

      } else if (removed) {
        // Torneo rimosso → elimina i suoi eventi dallo state, nessuna API call
        this.removeTournamentEvents(removed);
      }

      // Apertura accordion per tutti i tornei attivi (dopo eventuale fetch)
      if (next.length > 0) {
        await this.$nextTick();
        const idSet = new Set(next.map(id => String(id)));
        this.sectionizedGroups.forEach(item => {
          if (idSet.has(String(item.raw[0]?.tournamentId))) {
            this._userToggled[item.groupKey] = true;
            this.$set(this.openGroups, item.groupKey, true);
          }
        });
      }
    },
    sectionizedGroups: {
      handler(newGroups) {
        this._initOpenGroups(newGroups);
      },
      immediate: true,
    },
    getActiveSportId(id) {
      if (!this.isInHomePage) this.onSportSelected(id);
    },
    // React when the parent (PreliveSection) switches to a different sport.
    sportId(id) {
      if (this.isInHomePage && id) {
        this.fetchLive({sport: id, group: true, page: 1, limit: this.pageLimit, ishome: this.isInHomePage});
      }
    },
    // Se lo store viene svuotato dall'esterno (es. goHome() → resetPreviewLive)
    // mentre il componente è già montato, ri-fetcha subito anziché aspettare il polling.
    getGroupedEvents(newVal) {
      if (this.isInHomePage && !this.sportId && newVal.length === 0 && !this.getLoadingLive && !this._initMarketsRunning) {
        this.initMarkets();
      }
    },
    // Scroll to top when switching between live list and live detail (mirrors SportCenterRouter behaviour)
  },
  methods: {
    ...mapActions({
      'fetchLive': 'previewLive/fetchLiveV3ServerSide',
      'fetchAndMergeTournament': 'previewLive/fetchAndMergeTournament',
      'removeTournamentEvents': 'previewLive/removeTournamentEvents',
      'setLoadingLive': 'previewLive/setLoadingLive',
      'setLiveSportSelected': 'previewLive/setLiveSportSelected',
      'fetchLivePrimaryMarket': 'scrollerWidgetEventLive/fetchLivePrimaryMarket',
      'fetchEventLiveDetailV5': 'detailLive/fetchEventLiveDetailV5',
      'addOddToCartV3': 'cart/addOddToCartV3',
      'setActiveSportIdLivePreview': 'marketview/setActiveSportIdLivePreview',
      'setActiveTournamentIdLivePreview': 'marketview/setActiveTournamentIdLivePreview',
      'setViewMode': 'ui/setViewMode',
      'setSubaction':          'ui/setSubaction',
      'setMobileCartOpen':     'cart/setMobileCartOpen',
      'setProgramOpen':        'settings/setProgramOpen',
      'removeFromPreview':     'previewPrematch/removeFromPreview',
      'removeFromDetail':      'detailPrematch/removeFromDetail',
      'removeEventLiveDetail': 'detailLive/removeEventLiveDetail',
      'resetPreviewLive':      'previewLive/resetPreviewLive',
    }),

    stripScoreState(str) {
      return str ? String(str).replace(/\s*\(\d+-\d+\)\s*$/, '').trim() : str;
    },
    formatLineDisplay(line, marketDef) {
      if (line == null || String(line) === '') return '';
      let str = this.stripScoreState(String(line).trim());
      const mId = parseInt(marketDef.id || marketDef.marketId, 10);
      if (this.getMarketConfig.handicapIds.includes(mId)) {
        if (/^[0-9]/.test(str) && parseFloat(str) !== 0) return '+' + str;
      }

      if (MARKET_ASIAN_HANDICAP.includes(marketDef.id || marketDef.marketId) && !str.startsWith('-'))
        return '+' + str

      return str;
    },

    // Helper per il Dropdown Desktop (Mercati Principali)
    getDesktopSelectedIndex(colIdx) {
      // Usa desktopMarketIndices per mercati standard
      return this.desktopMarketIndices[colIdx] !== undefined ? this.desktopMarketIndices[colIdx] : colIdx;
    },
    onDesktopColumnChange(newVal, colIdx) {
      // Aggiorna desktopMarketIndices per mercati standard
      const val = parseInt(newVal, 10);
      this.$set(this.desktopMarketIndices, colIdx, val);
      // Nessun'altra azione necessaria, i computed ricalcoleranno tutto.
    },
    getAvailableMarketsForColumn(colIdx) {
      // Usa allHeaderMarkets e desktopMarketIndices per mercati standard
      const source = this.allHeaderMarkets || [];
      const currentSelection = this.desktopMarketIndices.slice(0, this.maxMarkets).map((idx, i) => idx !== undefined ? idx : i);

      return source.map((market, idx) => {
        // Disabilita l'opzione se è già selezionata in UN'ALTRA colonna
        const isSelectedElsewhere = currentSelection.includes(idx) && currentSelection[colIdx] !== idx;
        return {
          ...market,
          originalIndex: idx,
          disabled: isSelectedElsewhere
        };
      });
    },
    // Helper per il Dropdown Desktop
    getSourceMarkets(section) {
      if (!section) return this.allHeaderMarkets || [];
      if (section.isOvertime) return this.allHeaderMarketsOvertime || [];
      if (section.isPenalty) return this.allHeaderMarketsPenalty || [];
      return this.allHeaderMarkets || [];
    },

    isServing(livescore, position) {
      if (!livescore || !livescore.livescoreExtraData || !Array.isArray(livescore.livescoreExtraData)) return false;

      const serve = livescore.livescoreExtraData.find(e => e && e.name === 'Turn');
      if (!serve) return false;

      return String(position) === String(serve.value);
    },
    isTennisOrTableTennis(event) {
      return event && (String(event.sportId) === SPORT_ID.TENNIS || String(event.sportId) === SPORT_ID.TABLE_TENNIS);
    },

    getStat(ls, type, pos) {
      if (!ls) return 0;
      const stats = ls.Statistics || ls.statistics || [];
      const s = stats.find(stat => String(stat.Type || stat.type) == String(type));
      if (!s) return 0;
      const res = s.Results || s.results || [];
      const record = res.find(r => String(r.Position || r.position) == String(pos));
      return record ? (record.Value ?? record.value ?? 0) : 0;
    },

    // ── Incidents helpers ─────────────────────────────────────────────────
    getEffectiveIncidentId(event, position) {
      if (!event.livescore) return null;
      // Check dedicated activeGoalEvents state (immune to server overwrites)
      const goalPos = this.activeGoalEvents && this.activeGoalEvents[String(event.id)];
      if (goalPos) {
        if (!position || goalPos === String(position)) return INCIDENT_ID.GOAL;
      }
      // Fallback to real incident from server
      return event.livescore.currentIncident ? String(event.livescore.currentIncident.id) : null;
    },
    hasGoalIncident(event, position) {
      return this.getEffectiveIncidentId(event, position) === INCIDENT_ID.GOAL;
    },
    // Controlla lo stato VAR grezzo (senza linger), usato internamente dal watcher.
    _isVarActiveRaw(event) {
      if (!event) return false;
      if (this.getEffectiveIncidentId(event) === INCIDENT_ID.VAR) return true;
      const extra = event.livescore && event.livescore.livescoreExtraData;
      if (!Array.isArray(extra)) return false;
      const varEntry = extra.find(e => e && e.name === 'VAR');
      return varEntry != null && varEntry.value != null && varEntry.value !== '' && varEntry.value !== '0';
    },
    // Badge VAR: true se il segnale è attivo OPPURE se il linger da 10s è ancora in corso.
    hasVarIncident(event) {
      return !!this.varLinger[String(event.id)];
    },
    showRedCards(event) {
      return !this.hasGoalIncident(event) && !this.hasVarIncident(event);
    },
    // ── Fine Incidents helpers ────────────────────────────────────────────


    // ── Accordion ────────────────────────────────────────────────────────

    isGroupOpen(key) {
      return key in this.openGroups ? this.openGroups[key] : true;
    },

    toggleGroup(key) {
      const newVal = !this.isGroupOpen(key);
      this._userToggled[key] = true;
      this.$set(this.openGroups, key, newVal);
    },

    _initOpenGroups(groups) {
      if (!this._userToggled) this._userToggled = {};
      const THRESHOLD = 10;
      let cumulative = 0;

      // Remove stale keys for tournaments that are no longer in the list,
      // preventing openGroups / _userToggled from growing unboundedly.
      const currentKeys = new Set((groups || []).map(item => item.groupKey));
      for (const key in this.openGroups) {
        if (!currentKeys.has(key)) {
          this.$delete(this.openGroups, key);
          delete this._userToggled[key];
        }
      }

      (groups || []).forEach(item => {
        const key = item.groupKey;
        const eventCount = Array.isArray(item.raw) ? item.raw.length : 0;

        // Preserve only explicit user toggles; always recompute auto state
        if (!this._userToggled[key]) {
          this.$set(this.openGroups, key, cumulative < THRESHOLD);
        }
        cumulative += eventCount;
      });
    },
    // ── Fine Accordion ───────────────────────────────────────────────────


    _buildGridStyle(marketsCount) {
      const count = this.isSingleMarket ? 1 : (marketsCount || 1);
      return {
        display: 'grid',
        'grid-template-columns': `minmax(0, ${count}fr) repeat(${count}, minmax(0, 1fr)) 40px`,
        'align-items': 'stretch',
        'border-bottom': '1px solid var(--border-color)',
        width: '100%'
      };
    },

    _groupEventsByHeaders(events, baseHeaders) {
      const groupsMap = {};

      events.forEach(evt => {
        const evtHeaders = baseHeaders.map(header => {
          if (!header.candidates || header.candidates.length === 0) return header;

          for (const candidate of header.candidates) {
            const cId = String(candidate.marketId);
            const matches = (evt.odds || []).filter(m => String(m.id || m.marketId) === cId);
            const resolved = resolveEventMarket(matches, this.customLines[`${evt.id}_${cId}`]);

            if (resolved && this.isLinePlayable(resolved)) {
              return {
                ...header,
                originalKey: header.key,
                key: cId,
                marketId: cId,
                marketName: resolved.marketName || header.marketName,
                marketAlias: resolved.marketAlias || header.marketAlias,
                outcomeNames: resolved.outcome ? resolved.outcome.map(o => o.outcome_alias || o.outcome_name) : header.outcomeNames,
                outcomeNumbers: resolved.outcome ? resolved.outcome.length : header.outcomeNumbers
              };
            }
          }
          return header;
        });

        const signature = evtHeaders.map(h => String(h.key || h.marketId)).join('|');

        if (!groupsMap[signature]) {
          groupsMap[signature] = {headers: evtHeaders, events: []};
        }

        const resolvedGridMarkets = {};
        evtHeaders.forEach(header => {
          const mKey = String(header.key || header.marketId);
          const matches = (evt.odds || []).filter(m => String(m.id || m.marketId) === mKey);
          resolvedGridMarkets[mKey] = resolveEventMarket(matches, this.customLines[`${evt.id}_${mKey}`]);
        });

        groupsMap[signature].events.push({
          ...evt,
          resolvedGridMarkets
        });
      });

      return Object.values(groupsMap);
    },

    async loadMoreEvents() {
      if (this.getLoadingMore || !this.getPagination) return;
      const nextPage = this.getPagination.page + 1;

      await this.fetchLive({
        sport: this.getActiveSportIdLivePreview,
        page: nextPage,
        limit: this.getPagination.limit,
        ishome: this.isInHomePage
      });
    },

    getScoreString(event) {
      if (!event.livescore || !event.livescore.scoreboard || !event.livescore.scoreboard.results) return event.id + '_0-0';
      const r = event.livescore.scoreboard.results;
      const h = r.find(x => x.position == '1')?.value || 0;
      const a = r.find(x => x.position == '2')?.value || 0;
      return `${event.id}_${h}-${a}`;
    },

    isAboutToStart(event) {
      // FIX: Se l'evento è stato marcato come finito, ignora falsi positivi dallo status STARTING_SOON
      if (event.matchFinished) return false;
      return event.status === EVENT_STATUS.STARTING_SOON || event.livescore?.scoreboard?.status === EVENT_STATUS.STARTING_SOON;
    },
    getInfoTimeMatch(livescore, sport, status) {
      const currentPeriod = livescore && livescore.scoreboard && livescore.scoreboard.currentPeriod;

      if (currentPeriod && currentPeriod !== '-1') {
        return this.$t('periods.' + sport + '.' + currentPeriod);
      }

      if (status === EVENT_STATUS.STARTING_SOON || currentPeriod === CLOCK.INVALID) {
        return this.$t('periods.about_to_start');
      }

      return '';
    },
    getOutcomeName(c, o, unique_id) {

      if (MARKET_NOT_NAME_IN_OUTCOME.includes(unique_id)) {
        return o.outcome_alias || o.outcome_name;
      }

      if(o.name === 'Under') return "U"
      else if(o.name === 'Over') return "O"
      else return ""
      const outcome = o.outcome_name?.toLowerCase();

      if (o.outcome_name === 'X') {
        return o.outcome_alias || o.outcome_name;
      }

      if (this.getCompetitorsInOutcome) {
        if (outcome === 'local') {
          return c?.[0]?.name || o.outcome_alias || o.outcome_name;
        }

        if (outcome === 'visitante') {
          return c?.[1]?.name || o.outcome_alias || o.outcome_name;
        }

        if ((o.outcome_name === "1" || o.outcome_name === "2") && unique_id != DRAW_OUTCOME_ID) {
          for (let i = 0; i < c.length; i++) {
            if (c[i].position === o.outcome_name) {
              return c[i].name;
            }
          }
        }
      }

      return o.outcome_alias || o.outcome_name;
    },

    getNameForSportAvailable(item) {
      return item.name
    },
    getSportIdForSportAvailable(item) {
      return item.id
    },

    selectMobileMarket(index) {
      this.selectedMarketIndex = index;
    },

    isOddPlayable(odd) {
      return odd && odd.active && parseFloat(odd.outcome_odd_value) > 1;
    },

    getPlayerOutcomeLine(odd) {
      if (!odd.line) return null;
      if (odd.baseLine) {
        if (odd.line === odd.baseLine) return null;
        if (odd.line.startsWith(odd.baseLine + '#')) return odd.line.slice(odd.baseLine.length + 1);
        // Hide mirror handicap: "6.5 (0-0)" vs baseLine "-6.5 (0-0)" — same value, opposite sign
        const sLine = String(odd.line).replace(/\s*\(\d+-\d+\)\s*$/, '').trim();
        const sBase = String(odd.baseLine).replace(/\s*\(\d+-\d+\)\s*$/, '').trim();
        const nLine = parseFloat(sLine);
        const nBase = parseFloat(sBase);
        if (!isNaN(nLine) && !isNaN(nBase) && nLine === -nBase) return null;
      }
      const raw = odd.line.replace('#', ' · ');
      return raw.replace(/\s*\(\d+-\d+\)\s*$/, '').trim() || null;
    },
    // ── CLOCK MONOTONICO ─────────────────────────────────────────────────
    // Sport il cui timer SCENDE (basket, hockey): analoghi a MatchHero
    _isCountdownSport(sportId) {
      const id = parseInt(sportId);
      return COUNTDOWN_SPORT_IDS.has(id);
    },

    // Sincronizza il clock anchor per un evento dal valore server, con scudo monotonico.
    // Chiamato dal tick globale ogni secondo.
    _syncEventClock(event) {
      const rawTime = event.livescore?.scoreboard?.time;
      if (rawTime == null || rawTime === '-1' || rawTime === '0') return;
      const serverTime = parseInt(rawTime, 10);
      if (isNaN(serverTime) || serverTime < 0) return;

      const eventId = String(event.id);
      const isCountdown = this._isCountdownSport(event.sportId);
      const state = this._clockStates[eventId];

      if (!state) {
        // Prima inizializzazione: ancora sul valore server
        this._clockStates[eventId] = {
          anchorSeconds: serverTime,
          anchorWallMs: Date.now(),
          lastServerTime: serverTime,
          isCountdown,
        };
        return;
      }

      if (serverTime === state.lastServerTime) return; // nessun cambiamento dal server
      state.lastServerTime = serverTime;

      // Calcola il tempo che stiamo mostrando in questo momento
      const elapsedSec = Math.floor((Date.now() - state.anchorWallMs) / 1000);
      const currentDisplayed = state.isCountdown
          ? Math.max(0, state.anchorSeconds - elapsedSec)
          : state.anchorSeconds + elapsedSec;

      const diff = serverTime - currentDisplayed;
      // Scudo monotonico:
      //  - countdown: accetto solo se il server SCENDE (diff<0) o salto > 3 min (nuovo periodo)
      //  - count-up : accetto solo se il server SALE  (diff>0) o salto < -3 min (reset periodo)
      const shouldSync = state.isCountdown
          ? (diff < 0 || diff > 180)
          : (diff > 0 || diff < -180);

      if (shouldSync) {
        state.anchorSeconds = serverTime;
        state.anchorWallMs = Date.now();
        state.isCountdown = isCountdown;
      }
    },

    // Restituisce il numero di secondi da visualizzare per un evento.
    // Con ENABLE_LOCAL_CLOCK_TICK=true: usa l'anchor locale (smooth, monotonico).
    // Con ENABLE_LOCAL_CLOCK_TICK=false: legge direttamente il valore reattivo di
    //   Vuex (event.livescore.scoreboard.time), aggiornato solo da socket/polling.
    getDisplaySeconds(event) {
      if (!ENABLE_LOCAL_CLOCK_TICK) {
        return event.livescore?.scoreboard?.time;
      }
      // eslint-disable-next-line no-unused-vars
      const _tick = this.liveTick; // dipendenza reattiva
      const state = this._clockStates && this._clockStates[String(event.id)];
      if (!state) return event.livescore?.scoreboard?.time;
      const elapsedSec = Math.floor((Date.now() - state.anchorWallMs) / 1000);
      return state.isCountdown
          ? String(Math.max(0, state.anchorSeconds - elapsedSec))
          : String(state.anchorSeconds + elapsedSec);
    },
    // ── Fine Clock Monotonico ────────────────────────────────────────────

    isLinePlayable(marketLine) {
      return marketLine.outcome && marketLine.outcome.some(o => this.isOddPlayable(o));
    },

    getSpecifierType(specifier) {
      if (specifier == null || String(specifier) === '') return 'neutral';
      const str = String(specifier).trim();
      if (str.startsWith('-')) return 'negative';
      if (str.startsWith('+')) return 'positive';
      return 'neutral';
    },

    getAlternativeLinesFull(event, resolvedMarket) {
      if (!event.odds || !resolvedMarket) return [];
      const mId = String(resolvedMarket.id || resolvedMarket.marketId);
      return event.odds
          .filter(m =>
              String(m.id || m.marketId) === mId &&
              String(m.specifier) !== String(resolvedMarket.specifier) &&
              this.isLinePlayable(m)
          )
          .sort((a, b) => parseFloat(a.specifier) - parseFloat(b.specifier));
    },

    handleImgError(e) {
      e.target.style.display = 'none';
    },

    updateCatsArrows() {
      const el = this.$refs.catsScroll;
      if (!el) return;
      const {scrollLeft, scrollWidth, clientWidth} = el;
      this.showCatsLeftArrow = scrollLeft > 4;
      this.showCatsRightArrow = scrollLeft + clientWidth < scrollWidth - 4;
    },

    scrollCats(direction) {
      const el = this.$refs.catsScroll;
      if (!el) return;
      el.scrollBy({left: direction * 220, behavior: 'smooth'});
      setTimeout(this.updateCatsArrows, 300);
    },

    async goToEventDetail(event) {
      if (window.innerWidth < 1200 || window.forceMobileView === 'true') {
        window.scrollTo({top: 0, behavior: 'smooth'});
      } else {
        const target = document.querySelector('.col-scroll.center');
        if (target) {
          target.scrollTo({top: 0, behavior: 'smooth'});
        }
      }
      window.parent.postMessage({type: 'scrollToTop'}, '*');

      await this.getDetailOfEventLive(event.id, event.type, event.sportId, (event.tournamentId) ? event.tournamentId : '', event.status, event);
      if (this.isInHomePage) {
        this.setViewMode({mode: 'detail'});
      }
      this.fetchLivePrimaryMarket({sport: event.sportId});
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    async getDetailOfEventLive(eventSource, type, sport, tournament, status, event) {
      this.loading = true;
      await this.fetchEventLiveDetailV5({
        'source': eventSource, 'group': 0, 'sport': sport, 'tournament': tournament, 'status': status,
        sportName: event && event.sportName,
        categoryName: event && event.categoryName,
        tournamentName: event && event.tournamentName,
        competitorHome: event && event.home,
        competitorAway: event && event.away,
        competitorHomeId: event && event.home_id,
        competitorAwayId: event && event.away_id,
      });
      this.loading = false;
    },

    hasTime(event) {
      return event?.livescore?.scoreboard?.time && event.livescore?.scoreboard.time !== '-1';
    },
    getMatchCurrentTime(time) {
      if (time === undefined || time === null || time === '') return '';
      const timeNum = parseInt(time, 10);
      if (isNaN(timeNum) || timeNum < 0) return '';
      var minutes = Math.floor(timeNum / 60);
      var seconds = timeNum - minutes * 60;
      return (seconds < 10) ? minutes + ':0' + seconds : minutes + ':' + seconds;
    },
    getMatchCurrentPeriod(period) {
      if (!period) return '';
      if (Array.isArray(period)) {
        var find = _.find(period, {'lang': this.getLanguage}) || _.find(period, {'lang': 'en'});
        return find ? find.text : '';
      }
      return '';
    },

    getOddClasses(odd) {
      const classes = [];
      if (this.getOddsSources.includes(odd.unique_id)) classes.push('odd_selected');
      if (this.oddsVisualMode === 'blink') {
        if (odd.type_change === 'up') classes.push('odd_blink_up');
        else if (odd.type_change === 'down') classes.push('odd_blink_down');
      }
      return classes;
    },

    onResize() {
      const w = window.innerWidth;
      this.isSmallScreen = w <= 600;
      this.$nextTick(this.updateCatsArrows);
      this.$nextTick(this.updateSportsArrows);

      // MOSTRA 3 MARKET SOLO SE LO SCHERMO È MAGGIORE O UGUALE A 1650px
      if (w >= 1650) {
        this.maxMarkets = 3;
        this.infoColWidth = '350px';
        this.moreColWidth = '50px';
      }
      // SE LO SCHERMO È INFERIORE A 1650px (MA MAGGIORE DI 1000px), MOSTRA 2 MARKET
      else if (w > 1000) {
        this.maxMarkets = 2;
        this.infoColWidth = '300px';
        this.moreColWidth = '50px';
      } else if (w > 600) {
        this.maxMarkets = 1;
        this.infoColWidth = '250px';
        this.moreColWidth = '50px';
      } else {
        this.maxMarkets = 3;
        this.infoColWidth = '50%';
        this.moreColWidth = '30px';
      }
    },

    // 🔴 USA SEMPRE L'HEADER (mrktDef) PER CALCOLARE LE COLONNE
    getInnerGridStyle(mrktDef, resolvedMarket) {
      // Multi-market: outcomes stacked vertically
      if (!this.isSingleMarket) {
        return {
          display: 'flex',
          'flex-direction': 'column',
          'align-items': 'stretch',
          width: '100%',
          height: '100%',
        };
      }

      // Single market: outcomes in horizontal columns (existing logic)
      let hasSpec = this.shouldShowSpecifierPlaceholder(mrktDef) || this.hasSpecifier(resolvedMarket);
      let outcomesCount = mrktDef && mrktDef.outcomeNames ? mrktDef.outcomeNames.length : (mrktDef && mrktDef.outcomeNumbers ? mrktDef.outcomeNumbers : 3);

      if (hasSpec && this.isSmallScreen) {
        return {
          display: 'grid',
          gridTemplateColumns: 'repeat(6, 1fr)',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          gap: '0px',
          padding: '0'
        };
      } else {
        let columns = hasSpec ? '45px ' : '';
        columns += `repeat(${outcomesCount}, minmax(0, 1fr))`;
        return {
          'display': 'grid',
          'grid-template-columns': columns,
          'align-items': 'center',
          'width': '100%',
          'height': '100%',
          'gap': '0px',
          'padding': '0'
        };
      }
    },
    getOutcomeNamesForHeader(mrkt) {
      if (mrkt && mrkt.outcomeNames && mrkt.outcomeNames.length > 0) {
        return mrkt.outcomeNames;
      }
      const count = (mrkt && mrkt.outcomeNumbers) || 3;
      return Array(count).fill('');
    },

    getOutcomeStyle(mrktDef) {
      if (this.shouldShowSpecifierPlaceholder(mrktDef) && this.isSmallScreen) {
        const len = mrktDef.outcomeNames ? mrktDef.outcomeNames.length : (mrktDef.outcomeNumbers || 3);
        if (len === 2) {
          return {gridColumn: 'span 3'}
        }
        if (len === 3) {
          return {gridColumn: 'span 2'}
        }
      }
      return {}
    },

    hasSpecifier(oddMarket) {
      return oddMarket && oddMarket.specifier && oddMarket.specifier !== '' && oddMarket.specifier !== 'noSpec';
    },

    // Verifica in base alla configurazione dell'header o al nome
    shouldShowSpecifierPlaceholder(headerMarket) {
      if (!headerMarket) return false;
      if (headerMarket.marketWithSpecifier === true) return true;
      // Se il campo è esplicitamente false non fare il fallback sul nome
      // (evita false positive es. "overtime".includes('over'))
      if (headerMarket.marketWithSpecifier === false) return false;
      // Fallback per dati senza il campo: word-boundary per evitare substring match
      //todo evaluate to remove this hack. It need be always the Api that have the responsibility to decide if has specifier or not !
      const name = (headerMarket.marketName || '').toLowerCase();
      return /\bunder\b|\bover\b|\bhandicap\b|\bgoal\b/.test(name);
    },

    changeLine(event, marketOrDef, newSpecifier) {
      const mId = String(marketOrDef.marketId || marketOrDef.id);
      const key = `${event.id}_${mId}`;
      this.$set(this.customLines, key, String(newSpecifier));
    },

    updateSportsArrows() {
      const el = this.$refs.liveSportsScroll;
      if (!el) return;
      const {scrollLeft, scrollWidth, clientWidth} = el;
      this.showSportsLeftArrow = scrollLeft > 4;
      this.showSportsRightArrow = scrollLeft + clientWidth < scrollWidth - 4;
    },
    scrollSportsBar(direction) {
      const el = this.$refs.liveSportsScroll;
      if (!el) return;
      el.scrollBy({left: direction * 220, behavior: 'smooth'});
      setTimeout(this.updateSportsArrows, 300);
    },
    goPrematch() {
      const detailSources = (this.getEventsDetail || []).map(e => e.source).filter(Boolean);
      detailSources.forEach(source => this.removeFromDetail({ source }));

      const previewSources = [...(this.getTournamentsActive || [])];
      previewSources.forEach(source => this.removeFromPreview({ source }));

      const liveSources = [...(this.getEventsLiveDetailActive || [])];
      liveSources.forEach(source => this.removeEventLiveDetail(source));

      // Live-scoped: left set, it kept the prematch home filtered by the live
      // tree's tournament, and kept filtering after a sport change too.
      this.setActiveTournamentIdLivePreview([]);
      this.resetPreviewLive();
      this.setViewMode({mode: 'preview'});
      this.setSubaction('home');
      window.parent.postMessage({ type: 'removeSlugs' }, '*');
      window.scrollTo({top: 0, behavior: 'smooth'});
    },
    onSportSelected(id) {
      const sport = (this.getSportsLiveAvailable || []).find(s => String(s.id) === String(id));
      if (sport) this.changeLive(sport);
    },
    async changeLive(sport) {
      // Flag: impedisce al watcher getActiveTournamentIdLivePreview di fare un fetch
      // fantasma mentre i commit sono ancora in corso (sport non ancora aggiornato).
      this._changeLiveInProgress = true;
      try {
        await this.setLoadingLive(true);
        this.categories_filtered = [];
        this.selectedMarketIndex = 0;
        // Commit sincroni senza await: Vue li batcha in un unico flush,
        // così i watcher vedono stato coerente (tournament=[], sport=nuovo).
        this.setActiveTournamentIdLivePreview([]);
        this.setLiveSportSelected({data: {sport: sport.id, sport_id: sport._id}});
        this.setActiveSportIdLivePreview(sport.id);
        await this.fetchLive({
          sport: sport.id,
          sport_id: sport._id,
          group: true,
          page: 1,
          ishome: this.isInHomePage, ...(this.isInHomePage && {limit: this.pageLimit})
        });
      } finally {
        this._changeLiveInProgress = false;
      }
      await this.setLoadingLive(false);
      this.openGroups = {};
      this._userToggled = {};
      this.customLines = {};
      this._clockStates = {}; // reset clock stati del vecchio sport
      this._initOpenGroups(this.sectionizedGroups);
    },

    onSpreadSelectorPutCart({market, odd}, event, rawItem) {
      this.putCart(market, odd, event, rawItem.sport, {id: rawItem.categoryId}, {id: rawItem.tournamentId});
    },

    async putCart(oddMarket, odd, event, sport, category, tournament) {
      if (this.isOddPlayable(odd)) {
        await this.addOddToCartV3({oddMarket, odd, event, sport, category, tournament, type: 'live'});
        this.$root.$emit('forceUpdateSingleMultiple')
      }
    },
    filterCategory(id, closemenu) {
      const index = this.categories_filtered.indexOf(id);
      (index >= 0) ? this.categories_filtered.splice(index, 1) : this.categories_filtered.push(id);
      if (closemenu) closemenu();
      // Apre tutti gli accordion dei gruppi che passano il filtro attivo
      this.sectionizedGroups.forEach(item => {
        const catId = item.raw[0].categoryId;
        if (this.isFiltered(catId)) {
          const key = item.groupKey;
          this._userToggled[key] = true;
          this.$set(this.openGroups, key, true);
        }
      });
    },
    checkAllFilter() {
      this.categories_filtered = [];
      // Ri-inizializza gli accordion con la logica di soglia standard
      this.openGroups = {};
      this._userToggled = {};
      this._initOpenGroups(this.sectionizedGroups);
    },
    isFiltered(categoryId) {
      return (this.categories_filtered.length === 0) || this.categories_filtered.includes(categoryId);
    },
    isTournamentFiltered(tournamentId) {
      return !this.getActiveTournamentIdLivePreview || this.getActiveTournamentIdLivePreview.length === 0 || this.getActiveTournamentIdLivePreview.includes(tournamentId);
    },

    isEventExpanded(eventId) {
      return this.accordionEventId === eventId;
    },

    async toggleEventExpand(event) {
      if (this.accordionEventId === event.id) {
        await this.removeEventLiveDetail(event.id);
        this.accordionEventId = null;
        return;
      }
      if (this.accordionEventId) {
        await this.removeEventLiveDetail(this.accordionEventId);
      }
      this.accordionLoading = true;
      this.accordionEventId = event.id;
      try {
        await this.fetchEventLiveDetailV5({
          source: event.id,
          group: 0,
          sport: event.sportId,
          tournament: event.tournamentId || '',
          status: event.status,
          sportName: event.sportName,
          categoryName: event.categoryName,
          tournamentName: event.tournamentName,
          competitorHome: event.home,
          competitorAway: event.away,
          competitorHomeId: event.home_id,
          competitorAwayId: event.away_id,
        });
      } catch (e) {
        this.accordionEventId = null;
      } finally {
        this.accordionLoading = false;
      }
    },

    async initMarkets() {
      if (this._initMarketsRunning) return;
      this._initMarketsRunning = true;
      try {
        // I widget (isInHomePage:true) non fanno fetch se la sezione live principale
        // ha già caricato i dati: evita la doppia chiamata limit:10 + limit:100.
        // Eccezione: se è passato un sportId esplicito (es. PreliveSection) occorre
        // sempre fare la chiamata filtrata, altrimenti mostrerebbe lo sport precedente.
        // Eccezione 2: se il limite in store è diverso da pageLimit (es. PreliveSection
        // ha caricato con limit:100 e ora HomeView monta con limit:5) occorre rifare
        // il fetch con il limite corretto.
        const cachedLimit = this.getPagination && this.getPagination.limit;
        if (this.isInHomePage && !this.sportId && this.getGroupedEvents.length > 0 && cachedLimit === this.pageLimit) {
          this.onResize();
          return;
        }
        await this.setLoadingLive(true);
        await this.fetchLive({
          group: true,
          page: 1,
          ...(this.sportId && {sport: this.sportId}),
          ...(this.isInHomePage && {limit: this.pageLimit}),
          ishome: this.isInHomePage
        });
        await this.setLoadingLive(false);
        this.onResize();
        // Aspetta che Vue scarichi la coda watcher prima di liberare il lock,
        // così il watcher getGroupedEvents vede ancora _initMarketsRunning=true
        // e non ri-lancia initMarkets() quando l'API risponde con groupedEvents:[].
        await this.$nextTick();
      } finally {
        this._initMarketsRunning = false;
      }
    }
  },
  async mounted() {
    window.addEventListener('resize', this.onResize);
    // Baseline sport per il watcher getActiveTournamentIdLivePreview:
    // permette di distinguere sport-switch da eviction circolare.
    this._watcherPrevSportId = String(this.getActiveSportIdLivePreview || '');

    // ── Clock monotonico: stato non-reattivo per-evento ───────────────
    this._clockStates = {}; // { eventId: { anchorSeconds, anchorWallMs, lastServerTime, isCountdown } }
    this._clockTick = setInterval(() => {
      if (document.visibilityState !== 'visible') return;
      const groups = this.getGroupedEvents;
      if (groups) {
        const activeIds = new Set();
        groups.forEach(group => {
          if (!Array.isArray(group)) return;
          group.forEach(event => {
            activeIds.add(String(event.id));
            if (!event.matchFinished) this._syncEventClock(event);
          });
        });
        // Pulizia stati per eventi non più presenti → no memory leak
        for (const id in this._clockStates) {
          if (!activeIds.has(id)) delete this._clockStates[id];
        }
        // Pulizia customLines per eventi usciti (chiavi formato "eventId_marketId")
        for (const key of Object.keys(this.customLines)) {
          const sep = key.indexOf('_');
          if (sep !== -1 && !activeIds.has(key.substring(0, sep))) {
            this.$delete(this.customLines, key);
          }
        }
      }
      if (ENABLE_LOCAL_CLOCK_TICK) this.liveTick++; // forza ricalcolo getDisplaySeconds() in template
    }, 1000);
    // ─────────────────────────────────────────────────────────────────

    await this.initMarkets();
    this.$nextTick(this.updateSportsArrows);
    const ms = this.getLivePollingIntervalMs;
    if (ms > 0) {
      if (!this.isInHomePage) {
        // Sezione live principale: silent patch in-place (no spinner, no remount).
        this._pollTimer = setInterval(() => {
          if (document.visibilityState !== 'visible') return;
          // Pausa durante dettaglio evento live: l'update live-preview non serve.
          if (this.getEventsLiveDetail && this.getEventsLiveDetail.length > 0) return;
          this.$store.dispatch('previewLive/silentRefreshLivePreview');
        }, ms);
      } else if (!this.sportId) {
        // Widget homepage (nessun sportId): usa silentRefreshLivePreview con ishome:true.
        // Patch in-place degli eventi esistenti + inject solo se c'è posto (< limit).
        // Events usciti dal top-N ma ancora live restano a schermo; quelli finiti
        // vengono rilevati dal status-check e rimossi con l'animazione di uscita.
        // Il widget PreliveSection (sportId presente) non avvia un timer proprio:
        // il watcher sportId gestisce già il reload ad ogni cambio sport.
        this._pollTimer = setInterval(() => {
          if (document.visibilityState !== 'visible') return;
          // Poll live only when the user is actually on the prematch/home section.
          // If they switched to the dedicated live section (appSection='live'), skip.
          if (this.getAppSection !== 'prematch') return;
          this.$store.dispatch('previewLive/silentRefreshLivePreview', { ishome: true });
        }, ms);
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    if (this._clockTick) {
      clearInterval(this._clockTick);
      this._clockTick = null;
    }
    this._clockStates = {};
    if (this._pollTimer) {
      clearInterval(this._pollTimer);
      this._pollTimer = null;
    }
    if (this._varTimers) {
      Object.values(this._varTimers).forEach(t => clearTimeout(t));
      this._varTimers = {};
    }
  }
};
</script>

<style scoped>

.match-finished-badge {
  display: inline-block;
  font-size: var(--font-size-md);
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--color-primary, #a37e2c);
  border: 1px solid var(--color-primary, #a37e2c);
  border-radius: 3px;
  padding: 1px 4px;
}

.event-row--finished {
  opacity: 0.5;
  pointer-events: none;
}

/* New event: slides in from above with a brief accent border flash */
.event-matches--new {
  animation: liveEventSlideIn 0.7s ease-out both;
}

@keyframes liveEventSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-10px);
    box-shadow: inset 3px 0 0 var(--color-primary, #00e5ff);
  }
  40% {
    opacity: 1;
    transform: translateY(0);
    box-shadow: inset 3px 0 0 var(--color-primary, #00e5ff);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
    box-shadow: inset 3px 0 0 transparent;
  }
}

/* Finished event: fades out and collapses before being removed from the DOM */
.event-matches--leaving {
  animation: liveEventFadeOut 0.8s ease-in forwards;
  overflow: hidden;
  pointer-events: none;
}

@keyframes liveEventFadeOut {
  0% {
    opacity: 1;
    max-height: 150px;
  }
  100% { opacity: 0; max-height: 0; padding-top: 0; padding-bottom: 0; }
}

.filter-live-category { padding: 8px 8px 8px 0;  display: flex; align-items: center; justify-content: space-between; width: 100%; overflow: hidden; }
.filter-live-category.flex-end { justify-content: flex-end; }
.all-btn { flex-shrink: 0; margin-right: 12px !important; font-weight: 700; }
.categories-slide-wrapper { display: flex; align-items: stretch; flex: 1; min-width: 0; }
.cats-scroll-btn { flex: 0 0 22px; width: 22px; border: none; background: none; color: var(--text-platform, #fff); font-size: var(--font-size-9xl); cursor: pointer; opacity: 0.2; transition: opacity 0.2s; padding: 0; }
.cats-scroll-btn.active { opacity: 0.8; }
.cats-scroll-btn.active:hover { opacity: 1; }
.categories-slide-track { flex: 1; position: relative; min-width: 0; overflow: hidden; }
.cats-fade-edge { position: absolute; top: 0; bottom: 0; width: 18px; z-index: 2; pointer-events: none; }
.cats-fade-edge.left { left: 0; background: linear-gradient(to right, var(--bg-body, #14161d), transparent); }
.cats-fade-edge.right { right: 0; background: linear-gradient(to left, var(--bg-body, #14161d), transparent); }
.categories-slide { display: flex; align-items: center; overflow-x: auto; scroll-behavior: smooth; scrollbar-width: none; }
.categories-slide::-webkit-scrollbar { display: none; }
::v-deep .v-chip { margin-right: 8px !important; margin-bottom: 0 !important; flex-shrink: 0 !important; height: 32px; max-width: 100%; }
.img-flag-filter { width: 18px; height: auto; min-width: 18px; object-fit: contain; margin-right: 6px; display: block; }

.path-container { font-weight: 700; color: var(--text-op-50-platform); display: flex; align-items: center; justify-content: flex-start; overflow: hidden; min-width: 0; flex: 1; white-space: nowrap; }
.path-container img { width: 18px; margin-right: 8px; flex-shrink: 0; }
.tournament-text {font-weight: 700; overflow: hidden; text-overflow: ellipsis; flex: 1; }

.grid-cell.match-info-container { align-items: flex-start; flex-direction: column }
.grid-cell.match-info-container .info-header-block { display: flex; justify-content: space-between; align-items: center; flex: 1; width: 100%; margin-bottom: 2px; }
.grid-cell.match-info-container .info-header-block .tourn { color: var(--text-op-50-platform); font-size: var(--font-size-xl); white-space: nowrap; text-overflow: ellipsis; overflow: hidden; max-width: 70%; }
.grid-cell.match-info-container .info-body-block { display: flex; width: 100%; }
.clickable-cell { cursor: pointer }
/*@media (hover: hover) and (pointer: fine) { .event-row .col-info:hover .team-name { color: var(--color-primary-light); } }*/
/* Border di separazione tra eventi dello stesso torneo */
.matches-list {
  border-bottom: 1px solid var(--bg-card);
}
.matches-list:last-child {
  border-bottom: none;
}
.event-row{
  gap: 0;
}

/* Timer row sopra la riga evento — occupa tutta la larghezza */
.event-timer-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 10px;
}

.event-inline-timer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
}

.inline-time {
  font-size: var(--font-size-xl);
  color: var(--text-op-50-platform);
  line-height: 1;
}

.col-info {
  padding: 0 10px;
  justify-content: space-between;
  min-width: 0;
  overflow: hidden;
}

.col-center {
  justify-content: center;
}

/* Linee separatrici solo nelle righe evento (non header) */
.grid-row:not(.header-sub-row) .col-info {
  border-right: 1px solid var(--hsla-1);
}



/* Single-market header: outcome names as equal sub-columns */
.outcome-names-header {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
}

.outcome-name-col {
  flex: 1;
  text-align: center;
}

.outcome-name-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
}

.odd-line-val {
  margin-left: 2px;
}

.col-more {
  justify-content: center;
  border-right: none;
}

.header-title { color: var(--text-platform); font-weight: bold; }

.competitors-block { flex: 1; min-width: 0; padding-right: 5px; display: flex; flex-direction: column; justify-content: center; gap: 8px }
.team-name {
  font-weight: 500;
  font-size: var(--font-size-4xl);
  line-height: 16px;
  color: var(--text-platform);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  transition: color 0.2s;
}

.team-name img {
  width: 16px;
  height: auto;
  flex-shrink: 0;
}

.team-name span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 1;
}


/* ── Incident slide: srotolamento da sinistra (max-width) ───────────── */
.incident-slide-enter-active {
  transition: max-width 0.45s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.35s ease, padding 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}

.incident-slide-leave-active {
  transition: max-width 0.3s ease, opacity 0.2s ease, padding 0.3s ease;
}

.incident-slide-enter,
.incident-slide-leave-to {
  max-width: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  opacity: 0;
}

/* incidents-box: contenitore laterale, flex-shrink:0 per non essere compresso */
.incidents-box {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 3px;
}

/* nome competitor: si restringe quando compare un badge */
.competitor-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  transition: max-width 0.4s ease;
}

/* badge base */
.incident-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  padding: 0 5px;
  font-size: var(--font-size-xs);
  font-weight: 800;
  line-height: 14px;
  white-space: nowrap;
  overflow: hidden;
  max-width: 60px;
  flex-shrink: 0;
}

.goal-badge {
  background-color: var(--goal-bg, rgba(0, 200, 100, 0.15));
  border: 1px solid var(--goal-border, #00c864);
  color: var(--goal-border, #00c864);
  animation: incident-glow 1.5s infinite;
}

.var-badge {
  background-color: var(--var-bg, rgba(255, 165, 0, 0.15));
  border: 1px solid var(--var-border, #ffa500);
  color: var(--var-border, #ffa500);
  animation: incident-glow 2s infinite;
}

@keyframes incident-glow {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.55;
  }
}

/* ── Mock incidents control ──────────────────────────────────────────── */
.mock-incident-control {
  display: flex;
  justify-content: flex-end;
  padding: 2px 10px 4px;
}

.mock-incident-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: var(--font-size-md);
  padding: 2px 8px;
  border: 1px dashed var(--color-primary, #a37e2c);
  border-radius: 4px;
  background: transparent;
  color: var(--color-primary, #a37e2c);
  cursor: pointer;
  opacity: 0.65;
  transition: opacity 0.2s;
}

.mock-incident-btn:hover {
  opacity: 1;
}

.mock-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--text-op-50-platform, #888);
  transition: background 0.2s;
}
.mock-dot.goal { background: var(--goal-border, #00c864); }
.mock-dot.var  { background: var(--var-border, #ffa500); }

.label-live { animation: ping 1.5s infinite !important; text-align: center; font-style: initial !important; background-color: var(--color-accent) !important; color: white; padding: 5px 4px !important; border-radius: 4px; font-size: var(--font-size-2xl) !important; text-transform: uppercase; margin: 0 6px 0 0; line-height: 5px; }

.score-block { display: flex; flex-direction: column; align-items: flex-end; justify-content: center; min-width: auto; flex-shrink: 0; }
.match-score { font-size: var(--font-size-5xl); font-weight: bold; color: var(--color-accent);white-space: nowrap; }
.match-time { width: 100%; font-size: var(--font-size-xl); color: var(--text-op-50-platform); margin-bottom: 0px; display: flex;justify-content: space-between; align-items: center; }
.match-time div {
  display: flex;
  align-items: center;
}

.header-sub-row .grid-cell .outcome-box.placeholder,
.header-sub-row .grid-cell .outcome-box.header-text {
  height: auto;
}



.more-bets-btn {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s;
  touch-action: manipulation;
}

.more-bets-btn .v-icon {
  color: var(--text-op-50-platform) !important;
}

.more-bets-btn:hover {
  background-color: var(--bg-cell-hover);
  border-color: var(--border-color);
}

.more-bets-btn:active {
  opacity: 0.75;
}

.count-text { font-size: var(--font-size-xl); color: var(--text-op-50-platform); font-weight: bold; }

.blink_me { animation: blinker 1s linear infinite; }
@keyframes blinker { 50% { opacity: 0; } }
.path-container img { width: 18px; margin-right: 8px; }
.path-container { display: flex; align-items: center; overflow: hidden; justify-content: flex-start }
.tournament-single { position: relative; }
.empty-market-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: var(--text-op-50-platform);
  padding: 100px 0;
}

.empty-state-card {
  color: var(--text-op-50-platform);
  gap: 6px;
}

.empty-state-card svg {
  width: 50px;
  height: auto;
}

.empty-text_t {
  font-weight: bolder;
  font-size: var(--font-size-8xl);
}

.empty-text_p {
  font-size: var(--font-size-4xl);
}

/* ── Overtime divider ──────────────────────────────────────────────────── */
.overtime-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  height: 24px;
  background: var(--bg-card-gradient-to-r);
  border-top: 1px solid var(--border-color);
}

.overtime-divider::before,
.overtime-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border-color);
  opacity: 0.5;
}

.overtime-label {
  font-size: var(--font-size-xs);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--color-accent);
  white-space: nowrap;
  opacity: 0.85;
}

/* ── Overtime sub-header row ──────────────────────────────────────────── */
.header-overtime {
  border-left: 2px solid var(--color-accent);
  opacity: 0.9;
}

.overtime-section-label {
  font-size: var(--font-size-xs);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--color-accent);
  opacity: 0.7;
}

/* ── Penalty divider ───────────────────────────────────────────────────── */
.penalty-divider {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  height: 24px;
  background: var(--bg-card-gradient-to-r);
  border-top: 1px solid var(--border-color);
}

.penalty-divider::before,
.penalty-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: var(--border-color);
  opacity: 0.5;
}

.penalty-label {
  font-size: var(--font-size-xs);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--color-primary);
  white-space: nowrap;
  opacity: 0.85;
}

/* ── Penalty sub-header row ───────────────────────────────────────────── */
.header-penalty {
  border-left: 2px solid var(--color-primary);
  opacity: 0.9;
}

.penalty-section-label {
  font-size: var(--font-size-xs);
  font-weight: 700;
  text-transform: uppercase;
  color: var(--color-primary);
  opacity: 0.7;
}

/*ARTURO*/
.trigger-btn .chip-category.all-btn {
  background: transparent;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  height: 32px
}

.chip-category {
  border-radius: 50px !important;
  background-color: var(--color-primary) !important
}

.bet-console-prefix .sport-live-content .tournament-card-preview .tournament-single {
  margin-bottom: 0;
  border: none;
}

.bet-console-prefix .tournament-card-preview .tournament-card-header, .bet-console-prefix .sport-live-content .preview { border: none; }

.dropdown-trigger-wrapper { position: relative; display: inline-flex; flex-shrink: 0; }
.category-filter-badge { position: absolute; top: -2px; right: 0px; min-width: 16px; height: 16px; padding: 0 4px; border-radius: 8px; background: var(--color-primary); color: var(--text-platform); font-size: var(--font-size-md); font-weight: 700; line-height: 16px; text-align: center; pointer-events: none; z-index: 1; }

.list-category { display: flex; flex-direction: column; gap: 10px; }
.list-category .chip-category {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 12px 8px;
  font-size: var(--font-size-4xl);
  font-weight: bold;
  background: var(--bg-panel) !important
}

.list-category .chip-category.active {
  color: var(--color-primary);
  font-weight: bolder
}

@keyframes ping {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* 🔴 STILE BOTTONE LOAD MORE */
.load-more-wrapper {
  display: flex;
  justify-content: center;
}

.market-dropdown {
  width: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  transition: all 0.2s;
}
.market-dropdown--extended {
  width: 100%;
}
.filters-header--extended {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* MEDIA QUERIES */
@media (max-width: 600px) {
  .event-row { min-height: 64px; }
  .grid-cell { padding: 0 6px; }
  .col-info { padding: 0 8px; }
  .outcome-box { height: 44px; }
  .team-name { font-size: var(--font-size-3xl); }
  .match-score { font-size: var(--font-size-4xl); }
  ::v-deep .v-chip { height: 36px !important; font-size: var(--font-size-3xl) !important; }
  .filter-live-category { padding: 6px 0; }
  .more-bets-btn { min-height: 44px; }
  .outcome-box { width: 100%; height: 44px; display: flex; justify-content: center; align-items: center; text-align: center; }
  .more-bets-btn { width: 100%; height: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; background-color: var(--bg-cell); border-radius: 4px; cursor: pointer; transition: 0.2s; border: 1px solid var(--border-color); touch-action: manipulation; }
  .more-bets-btn:active { opacity: 0.75; }
  .overtime-divider { height: 20px; }
  .penalty-divider  { height: 20px; }
}

/* ── Accordion ────────────────────────────────────────────────────── */
.accordion-header {
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
  position: relative;
}

.accordion-header:hover {

}

.accordion-header--closed {
  border-bottom: 1px solid transparent !important;
}

.accordion-chevron {
  flex-shrink: 0;
  opacity: 0.6;
  transition: opacity 0.15s;
}

.accordion-header:hover .accordion-chevron {
  opacity: 1;
}

/* Chevron dentro col-more (desktop): centrato nella cella */
.col-more .accordion-chevron {
  display: flex;
  margin: auto;
}

/* Chevron mobile: posizione assoluta a destra della riga */
.accordion-chevron--abs {
  position: absolute !important;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
}

/* ── Live Sports Bar (replaces SmartToolbar) ────────────────────────── */

/* Aggiunge la riga grigia sottile alla base di tutta la barra */
.lsb-scroll-track {
  position: relative;
  min-width: 0;
  overflow: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

/* Rimuove il gap per unire i tab e toglie il padding inferiore */
.lsb-scroll {
  display: flex;
  gap: 0;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  padding-bottom: 0;
}

/* Trasforma i bottoni in veri e propri Tab piatti */
.lsb-sport-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 56px;
  padding: 12px 16px;
  flex-shrink: 0;
  border: none;
  border-radius: 0; /* Rimosso il bordo arrotondato */
  background: transparent;
  cursor: pointer;
  position: relative; /* Fondamentale per posizionare la linea attiva */
  transition: opacity 0.2s ease;
}

/* Disabilita l'animazione di salto in alto (sui tab non sta bene) */
@media (hover: hover) {
  .lsb-sport-btn:hover { transform: none; opacity: 0.8; }
}

.lsb-sport-btn div {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  width: 100%;
}

/* Icone e testo attenuati di default */
.lsb-sport-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  opacity: 1;
  transition: opacity 0.2s;
}

.lsb-sport-name {
  font-size: var(--font-size-2xl);
  font-weight: 500;
  color: var(--text-op-50-platform);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 68px;
  transition: color 0.2s, font-weight 0.2s;
}

/* --- STATO ATTIVO --- */
/* Riaccende l'icona e il testo quando selezionato */
.lsb-sport-btn.is-active .lsb-sport-icon {
  opacity: 1;
}

.lsb-sport-btn.is-active .lsb-sport-name {
  color: #ffffff;
  font-weight: 700;
}

/* Genera la linea bianca inferiore per lo stato attivo */
.lsb-sport-btn::after {
  content: '';
  position: absolute;
  bottom: -1px; /* Si sovrappone esattamente alla linea grigia di base */
  left: 12px; /* Margini per centrare la riga in base alla larghezza del testo/icona */
  right: 12px;
  height: 3px;
  background-color: transparent;
  border-radius: 3px 3px 0 0;
  transition: background-color 0.2s ease;
}

.lsb-sport-btn.is-active::after {
  background-color: #ffffff; /* Accende la riga bianca */
}

.lsb-bar {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 0 20px;
}

.lsb-scroll-wrapper {
  flex: 1;
  position: relative;
  min-width: 0;
}

.lsb-scroll-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 28px;
  height: 28px;
  background: var(--hsla-4);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  color: var(--text-platform, #fff);
  font-size: var(--font-size-8xl);
  line-height: 1;
  cursor: pointer;
  user-select: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
}

.lsb-scroll-btn.left  { left:  4px; }
.lsb-scroll-btn.right { right: 4px; }

.lsb-scroll-wrapper:hover .lsb-scroll-btn.active {
  opacity: 1;
  pointer-events: auto;
}

.lsb-scroll-btn.active:hover {
  opacity: 1;
  filter: brightness(1.2);
}

.lsb-fade-edge {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 18px;
  z-index: 2;
  pointer-events: none;
}

.lsb-fade-edge.left {
  left: 0;
  background: linear-gradient(to right, var(--bg-body, #14161d), transparent);
}

.lsb-fade-edge.right {
  right: 0;
  background: linear-gradient(to left, var(--bg-body, #14161d), transparent);
}



.lsb-prematch-pinned {
  margin-left: 10px;
  flex-shrink: 0;
}

.cards-box {
  display: flex;
  gap: 2px;
}

.card-min {
  width: 7px;
  height: 10px;
  border-radius: 1px;
  cursor: pointer;
  font-size: var(--font-size-xxs);
  font-weight: bolder;
  line-height: 8px;
  display: flex;
  align-items: center;
  justify-content: center
}

.red {
  background: var(--danger, #ef4444);
}

@media (max-width: 600px) {
  .lsb-bar {
    padding: 8px 0 20px 0;

  }
}

.ping-serving {
  height: 5px;
  width: 5px;
  background: var(--bg-card);
  border-radius: 50%;
  left: -8px;
  top: 7px;
  z-index: 10;
}

.ping-serving.live {
  background: var(--color-secondary);
  animation: ping 1s infinite;
}

@keyframes ping {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% { opacity: 0.6; transform: scale(1.2); }
  100% { opacity: 1; transform: scale(1); }
}

@media (max-width: 600px) {
  .lsb-fade-edge.left  { left: 0;  background: linear-gradient(to right, transparent, transparent); }
  .lsb-fade-edge.right { right: 0; background: linear-gradient(to left,  transparent, transparent); }
}

/* ── Extended view (mobile only) ───────────────────────────────────── */
.header-sub-row{
  border-radius: 0;
  margin-bottom: 0!important;
  background: var(--bg-card);
}

.event-row{
  border-radius: 0;
  margin-bottom: 0!important;

}

.tournament-card-preview{
  border-radius: 0;

}

.value{
  border-radius: 0;
}

@media (hover: hover) {
  .value:not(.more-btn):hover {
    background: var(--bg-cell-hover);
    border-bottom: 1px solid transparent;
    color: var(--text-bg-cell-hover);
  }
}
.grid-cell.col-center{
  padding: 0!important;
}
.match-info-container{
  padding: 0 10px!important;

}

.outcome-box{
  height: 100%;
}

.value .outcome-name, .value .odd-line-val{
  font-size: var(--font-size-2xl);
  color: var(--text-op-50-platform);
}

@media (hover: hover) {
  .value[data-v-56c2483e]:not(.more-btn):hover .outcome-name {
    color: var(--text-op-50-platform);
  }
}


span.market-header-text{
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}

/* ── Event expand button ────────────────────────────────────────── */
.mlp-expand-cell {
  display: flex;
  align-items: stretch;
  justify-content: center;
  padding: 0 !important;
}

.mlp-expand-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: none;
  border: none;
  border-left: 1px solid var(--hsla-1);
  cursor: pointer;
  color: var(--text-op-50-platform);
  transition: color 0.15s, background 0.15s;
  padding: 0;
}

.mlp-expand-btn:hover {
  color: var(--text-platform);
  background: var(--bg-card);
}

.mlp-expand-btn.open {
  color: var(--color-primary-light);
  background: var(--bg-cell-hover);
}
.mlp-expand-btn.open svg {
  transform: rotate(90deg);
}

/* ── Accordion live detail ──────────────────────────────────────── */
.mlp-event-accordion {
  overflow: hidden;
  border-top: 1px solid var(--hsla-1);
}

.mlp-accordion-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.mlp-detail-fade-enter-active,
.mlp-detail-fade-leave-active {
  transition: max-height 0.3s ease, opacity 0.2s ease;
  max-height: 1200px;
}

.mlp-detail-fade-enter,
.mlp-detail-fade-leave-to {
  max-height: 0;
  opacity: 0;
}

.odd_selected{
  background: var(--bg-cell-active)!important;
  color: var(--text-cell-active)!important;
  border-color: transparent;
}
</style>